module.exports = __webpack_public_path__ + "img/estimated-insurance-required-output.1eaa0b9b.png";